<app-modal-base
	[headerTitle]="getI18nString(true, 'title' )"
	[hideModalPreFooter]="false"
	[hideModalSubheader]="false"
	[modalIdentifier]="modalIdentifier"
	[modalMainStyleClasses]="'overflow-y-hidden px-0 pb-1'"
	[modalSubheaderStyleClasses]="'px-0 px-md-5 pb-0'"
	[renderModalAside]="false"
	[renderModalSubheader]="false"
	(modalBaseEvent)="onModalBaseEvent($event)"
>

	<!-- MAIN -->
	<ng-container class="main-content">
		<div class="selectVersionModalWrapper col-12 px-0 h-100">
			<div class="d-flex flex-column pt-2 pt-md-5 h-100">

				<!-- Sticky Content -->
				<app-sticky-content
					class="px-2 px-md-5"
					[backgroundMode]="'transparent'"
				>

					<!-- Modal Introduction Description -->
					<div class="text-center">
						<ng-container *ngTemplateOutlet="modalDescriptionTpl"></ng-container>
					</div>

					<!-- Table Header -->
					<app-table
						class="d-block mx-auto maxWidth-limit versions-table-header"
						[tableConfig]="showResult ? resultHeaderTableConfig : headerTableConfig"
					>
						<ng-template
							#tableHeaderItemTpl
							let-cellItem="cellItem"
						>

							<!-- OPTIONS -->
							<div
								*ngIf="cellItem.identifier === 'options'"
								class="options d-flex flex-column justify-content-center"
							>

								<!-- Label -->
								<div class="optionsLabel fs-md fw-medium">
									{{ getI18nString( true, 'options.label' ) }}
								</div>

								<!-- Option Items -->
								<div>

									<!-- Show Result -->
									<ng-container
										[ngTemplateOutlet]="optionsItemTpl"
										[ngTemplateOutletContext]="{
											translationPath: 'options.result.text',
											styleClass: 'result',
											model: showResult,
											modelName: 'showResult',
											isCollapsed: !(hasOverwrites && selectedVersion === versionType.LOCAL)
										}"
									></ng-container>

									<!-- Copy to Clipboard -->
									<ng-container
										[ngTemplateOutlet]="optionsItemTpl"
										[ngTemplateOutletContext]="{
											translationPath: 'options.clipboard.text',
											styleClass: 'clipboard',
											model: withClipboard,
											modelName: 'withClipboard'
										}"
									></ng-container>

									<!-- Show Overwrite -->
									<ng-container
										[ngTemplateOutlet]="optionsItemTpl"
										[ngTemplateOutletContext]="{
											translationPath: 'options.overwrite.text',
											styleClass: 'overwrite',
											model: showOverwrite,
											modelName: 'showOverwrite',
											isCollapsed: !hasOverwrites
										}"
									></ng-container>

									<!-- Show Diff -->
									<ng-container
										[ngTemplateOutlet]="optionsItemTpl"
										[ngTemplateOutletContext]="{
											translationPath: 'options.diff.text',
											styleClass: 'diff',
											model: showDiff,
											modelName: 'showDiff',
											isCollapsed: showResult
										}"
									></ng-container>
								</div>
							</div>

							<!-- Result -->
							<ng-container
								*ngIf="cellItem.identifier === 'result'"
								[ngTemplateOutlet]="versionHeaderItemTpl"
								[ngTemplateOutletContext]="{ translationPath: 'versionHeaders.result' }"
							></ng-container>

							<!-- YOUR VERSION -->
							<ng-container
								*ngIf="cellItem.identifier === 'local'"
								[ngTemplateOutlet]="versionHeaderItemTpl"
								[ngTemplateOutletContext]="{ translationPath: 'versionHeaders.local', version: versionType.LOCAL }"
							></ng-container>

							<!-- DB VERSION	-->
							<ng-container
								*ngIf="cellItem.identifier === 'db'"
								[ngTemplateOutlet]="versionHeaderItemTpl"
								[ngTemplateOutletContext]="{ translationPath: 'versionHeaders.db', version: versionType.DB }"
							></ng-container>
						</ng-template>
					</app-table>
				</app-sticky-content>

				<!-- Scrollable Content -->
				<div
					id="scrollableContent"
					class="px-2 px-md-5 pb-4 overflow-y-scroll overflow-x-hidden"
				>

					<!-- Table Body -->
					<app-table
						class="d-block mx-auto maxWidth-limit"
						[tableConfig]="showResult ? resultBodyTableConfig : bodyTableConfig"
					>

						<ng-template
							#tableBodyItemTpl
							let-cellItem="cellItem"
							let-rowIdx="rowIdx"
						>

							<!-- Label -->
							<ng-container
								*ngIf="cellItem.identifier === 'label'"
								[ngTemplateOutlet]="versionLabelTpl"
								[ngTemplateOutletContext]="{ listItm: cellItem.value, idx: rowIdx }"
							></ng-container>

							<!-- RESULT -->
							<ng-container
								*ngIf="cellItem.identifier === 'result'"
								[ngTemplateOutlet]="resultTpl"
								[ngTemplateOutletContext]="{ listItm: cellItem.value, idx: rowIdx }"
							></ng-container>

							<!-- YOUR VERSION -->
							<ng-container
								*ngIf="cellItem.identifier === 'local'"
								[ngTemplateOutlet]="versionItemTpl"
								[ngTemplateOutletContext]="{mainEntity: localVersion, subEntity: dbVersion, listItm: cellItem.value, version: versionType.LOCAL, idx: rowIdx }"
							></ng-container>

							<!-- DB VERSION	-->
							<ng-container
								*ngIf="cellItem.identifier === 'db'"
								[ngTemplateOutlet]="versionItemTpl"
								[ngTemplateOutletContext]="{ mainEntity: dbVersion, subEntity: localVersion, listItm: cellItem.value, version: versionType.DB, idx: rowIdx }"
							></ng-container>
						</ng-template>
					</app-table>
				</div>
			</div>
		</div>
	</ng-container>

	<!-- PRE-FOOTER -->
	<ng-container class="pre-footer-content">
		<div class="buttons text-center">
			<ng-container *ngTemplateOutlet="modalFooterTpl"></ng-container>
		</div>
	</ng-container>
</app-modal-base>

<!-- ######################### TEMPLATES ######################### -->
<!-- MODAL DESCRIPTION -->
<ng-template #modalDescriptionTpl>
	<p class="description fw-regular">{{ getI18nString( true, 'issueDescription' ) }}</p>
</ng-template>

<!-- MODAL FOOTER -->
<ng-template #modalFooterTpl>
	<button
		type="button"
		class="btn confirmBtn"
		[ngClass]="{'disabled': !selectedVersion}"
		(click)="confirm()"
	>
		{{ getI18nString( false, 'shared.buttons.confirm' ) | uppercase }}
	</button>
</ng-template>

<!-- VERSION OPTIONS ITEM -->
<ng-template
	#optionsItemTpl
	let-translationPath="translationPath"
	let-styleClass="styleClass"
	let-model="model"
	let-modelName="modelName"
	let-isCollapsed="isCollapsed"
>
	<div
		class="row mx-0 mt-2 flex-nowrap optionsItem fw-medium"
		[ngbCollapse]="isCollapsed"
		(click)="updateOptions(modelName)"
	>
		<input
			class="col-auto mt-1 align-self-start"
			type="checkbox"
			[ngModel]="model"
		>

		<span class="col pe-3 {{styleClass}}">
			{{ getI18nString( true, translationPath ) }}
		</span>
	</div>
</ng-template>

<!-- VERSION HEADER ITEM -->
<ng-template
	#versionHeaderItemTpl
	let-translationPath="translationPath"
	let-version="version"
>
	<div
		class="py-3 text-center versionSelectItem d-flex flex-column justify-content-center"
		[ngClass]="{
		 	'selected': selectedVersion === version,
			'hovered': hoveredVersion === version,
			'pe-none': !version
		}"
		(click)="selectedVersion = version ?? selectedVersion"
		(mouseover)="hoveredVersion = version ?? hoveredVersion"
		(mouseleave)="hoveredVersion = version ? null : hoveredVersion"
	>
		<p class="title fs-md fw-medium mb-0">
			{{ getI18nString( true, translationPath + '.title' ) | uppercase }}
		</p>

		<small class="description fs-s fw-regular">
			{{ getI18nString( true, translationPath + '.description' ) }}
		</small>
	</div>
</ng-template>

<!-- VERSION LABEL -->
<ng-template
	#versionLabelTpl
	let-listItm="listItm"
	let-idx="idx"
>
	<p class="d-flex justify-content-end align-items-center my-0 pe-3 text-end">
		{{ getI18nString( false, listItm?.i18nPath + '.label' ) }}
	</p>
</ng-template>

<!-- VERSION ITEM -->
<ng-template
	#versionItemTpl
	let-mainEntity="mainEntity"
	let-subEntity="subEntity"
	let-listItm="listItm"
	let-version="version"
	let-idx="idx"
>
	<div
		class="d-flex justify-content-center align-items-center px-1 versionItemContent"
		[ngClass]="{
			'selected': selectedVersion === version,
			'hovered': hoveredVersion === version,
			'firstItem': idx === 0,
			'lastItem': idx === list.length - 1
		}"
		(mouseover)="hoveredVersion = version"
		(mouseleave)="hoveredVersion = null"
		(click)="selectedVersion = version"
	>
		<p
			class="mb-0 fs-md fw-medium"
			[ngClass]="{
			 'diff': showDiff && listItm?.comparisonResult === comparisonResult.IS_DIFFERENT,
			 'overwrite text':
				 showOverwrite &&
				 version !== versionType.DB &&  hasOverwrites &&
				 listItm?.comparisonResult === comparisonResult.WILL_OVERWRITE
		 	}"
			appHighlightText
			[disableHighlighting]="listItm?.comparisonResult === comparisonResult.WILL_OVERWRITE"
			[fireChange]="showDiff || showOverwrite"
			[revertMatch]=searchRevert
			[search]="version === versionType.DB ? listItm?.localValue: listItm?.dbValue "
			[text]="version === versionType.DB ? listItm?.dbValue : listItm?.localValue"
		></p>
	</div>
</ng-template>

<!-- RESULT-->
<ng-template
	#resultTpl
	let-listItm="listItm"
	let-idx="idx"
>
	<div
		class="d-flex justify-content-center align-items-center px-1 versionItemContent pe-none"
		[ngClass]="{
			'firstItem': idx === 0,
			'lastItem': idx === list.length - 1
		}"
	>
		<p
			class="mb-0 fs-md fw-medium"
			[ngClass]="{
				'overwrite text':	 showOverwrite && hasOverwrites && listItm?.comparisonResult === comparisonResult.WILL_OVERWRITE
			}"
		>
			{{ listItm?.overwriteValue }}
		</p>
	</div>
</ng-template>
